<div class="flex flex-col items-center relative bg-white" [style.borderRadius.px]="15">
    <h2 class="my-5">{{badge.title}}</h2>
    <img class="badge-img" [src]="badge.image">
    <p class="my-5 whitespace-pre-line w-3/4 text-center">{{badge.description}}</p>
    <button class="relative bottom-0 left-0" mat-dialog-close>Ok</button>
</div>